import { PantallaPendiente } from "@components/ui_v2";

export const RevisionExpedienteDefault = () => (
  <PantallaPendiente
    eyebrow="Expediente · En revisión"
    title="Tu expediente está en revisión"
    subtitle="Estamos validando los documentos y la información que enviaste. Te avisaremos por correo y WhatsApp en cuanto haya novedades."
  />
);
